// Central RBAC helpers for the admin app.
//
// Roles:
//   - super_admin: full access, bypasses all permission checks
//   - admin: access limited to their granted `permissions` array
//
// `userInfo` is the object stored in sessionStorage on login.

export const ADMIN_ROLES = ["admin", "super_admin"];

export const isAdminRole = (userInfo) =>
  ADMIN_ROLES.includes(userInfo?.user_type);

export const isSuperAdmin = (userInfo) =>
  userInfo?.user_type === "super_admin";

export const hasPermission = (userInfo, key) =>
  isSuperAdmin(userInfo) || Boolean(userInfo?.permissions?.includes(key));

// Ordered map of routes -> the permission key that gates them. Used both for
// the redirect fallback and to keep route/sidebar gating in sync.
export const ROUTE_PERMISSIONS = [
  { path: "/dashboard", permission: "dashboard" },
  { path: "/customers", permission: "customers" },
  { path: "/subscription-management", permission: "subscriptionManagement" },
  { path: "/referrals", permission: "referrals" },
  { path: "/invoicing", permission: "invoicing" },
  { path: "/audit-trial", permission: "auditTrail" },
  { path: "/reports", permission: "reports" },
  { path: "/communication", permission: "communication" },
  { path: "/support-tickets", permission: "supportTickets" },
  { path: "/feedback", permission: "feedback" },
];

// First route the user is allowed to land on. Falls back to /my-profile, which
// is always accessible, so an admin without any page permission never loops.
export const firstAllowedRoute = (userInfo) => {
  if (isSuperAdmin(userInfo)) return "/dashboard";
  const allowed = ROUTE_PERMISSIONS.find((r) =>
    hasPermission(userInfo, r.permission),
  );
  return allowed ? allowed.path : "/my-profile";
};
